/**
 * Created by rcabr on 5/2/2016.
 */
angular.module('eStories.paging', [
    /*eStories Paging*/
    'eStories.paging.model'
])

    .component('pagingBar', {
        transclude: true,
        controller: 'PagingCtrl',
        controllerAs: 'pagingCtrl',
        templateUrl: '/components/templates/paging/pagingBar.tmpl.html'
    })

    .controller('PagingCtrl', ['$rootScope', '$state',
        function ($rootScope, $state) {
            var pagingCtrl = this;
            pagingCtrl.getPagingData = function () {
                return $rootScope.pagingModel.pagingData[$state.current.name];
            };


            pagingCtrl.showLoadMoreButton = true;

            $rootScope.$on('hasMoreBooksToLoad', function (event, boolean) {
                pagingCtrl.showLoadMoreButton = boolean;
            });

            pagingCtrl.isPageNumberValid = function (pageNumber) {
                if (pageNumber > 0 && pageNumber <= $rootScope.pagingModel.pagingData[$state.current.name].totalPageCount) {
                    return pageNumber;
                }
                return '';
            };

            pagingCtrl.getPage = function (pageNumber, isMobile) {
                if (pagingCtrl.isPageNumberValid(pageNumber) != '') {
                    if (isMobile) {
                        $rootScope.$broadcast('loadMore', pageNumber);
                    } else {
                        $rootScope.$broadcast('getPage', pageNumber);
                    }
                }
            };
        }]);

